module.exports = __webpack_public_path__ + "img/assessment.48eab9ac.svg";